import moment from "moment";

/** Merged into map shipment `filters` when calling `getOrderFetchFilters` (not sent to the API). */
export const MAP_ORDER_FETCH_USE_CUSTOM_DATE = "__useCustomOrderDateRange";

export const getShipmentFetchFilters = (filters) => {
  const fetchFilters = {};

  if (filters.shipmentCity != "all") {
    fetchFilters.cityId = +filters.shipmentCity;
  }

  if (filters.shipmentStatus != "all") {
    fetchFilters.shipmentStatuses = [+filters.shipmentStatus];
  }

  if (filters.shipmentMerchant != "all") {
    fetchFilters.merchantId = +filters.shipmentMerchant;
  }

  if (filters.shipmentType != "all") {
    fetchFilters.shipmentType = filters.shipmentType;
  }
  if (filters.shipmentHubOpen != "all") {
    fetchFilters.hubOpen = filters.shipmentHubOpen === "true"
  }

  if (filters.shipmentReadySince) {
    fetchFilters.readySince = moment().subtract(+filters.shipmentReadySince, "days").format("YYYY-MM-DD")
  }

  return fetchFilters

}


export const getOrderFetchFilters = (filters, isShipmentFilterModalActive) => {
  const fetchFilters = {};

  if (filters.shipmentOrderStatus && filters.shipmentOrderStatus != "all") {
    fetchFilters.orderStatuses = filters.shipmentOrderStatus;
  }

  if (filters.shipmentMerchant && filters.shipmentMerchant != "all") {
    if (Array.isArray(filters.shipmentMerchant)) {
      fetchFilters.merchantIds = filters.shipmentMerchant.map(id => +id)
    } else {
      fetchFilters.merchantIds = [parseInt(filters.shipmentMerchant)]
    }
  }

  if (filters.shipmentType && filters.shipmentType != "all") {
    fetchFilters.shipmentTypes = filters.shipmentType;
  }

  if (filters.shipmentPaymentMethod != "all") {
    fetchFilters.paymentTypes = filters.shipmentPaymentMethod
  }

  if (filters.shipmentHubOpen != "all") {
    fetchFilters.isHubActive = filters.shipmentHubOpen === "true"
  }

  if (filters.hubIds && filters.hubIds != "all") {
    if (Array.isArray(filters.hubIds)) {
      fetchFilters.hubIds = filters.hubIds.map(id => +id)
    } else {
      fetchFilters.hubIds = [parseInt(filters.hubIds)]
    }
  }

  const fromRaw = filters.shipmentDateFrom;
  const toRaw = filters.shipmentDateTo;
  const fromM = fromRaw && moment(fromRaw, "YYYY-MM-DD", true).isValid() ? moment(fromRaw, "YYYY-MM-DD") : null;
  const toM = toRaw && moment(toRaw, "YYYY-MM-DD", true).isValid() ? moment(toRaw, "YYYY-MM-DD") : null;
  const useCustomDateRange = filters[MAP_ORDER_FETCH_USE_CUSTOM_DATE] === true;

  if (useCustomDateRange) {
    if (fromM && toM) {
      const dMin = fromM.isAfter(toM) ? toM : fromM;
      const dMax = fromM.isAfter(toM) ? fromM : toM;
      fetchFilters.startDate = dMin.clone().startOf("day").toISOString();
      fetchFilters.endDate = dMax.clone().endOf("day").toISOString();
    } else if (fromM) {
      fetchFilters.startDate = fromM.clone().startOf("day").toISOString();
      fetchFilters.endDate = fromM.clone().endOf("day").toISOString();
    } else if (toM) {
      fetchFilters.startDate = toM.clone().startOf("day").toISOString();
      fetchFilters.endDate = toM.clone().endOf("day").toISOString();
    }
  } else if (filters.shipmentReadySince) {
    fetchFilters.startDate = moment().subtract(+filters.shipmentReadySince, "days").format("YYYY-MM-DD")
    fetchFilters.endDate = moment().format("YYYY-MM-DD")
  }

  if (filters.onlyScheduledOrders != null) {
    fetchFilters.onlyScheduledOrders = Boolean(filters.onlyScheduledOrders);
  }

  if (filters.startingDistance != null ) {
    fetchFilters.startingDistance = parseInt(filters.startingDistance, 10);
  }

  if (filters.endingDistance != null ) {
    fetchFilters.endingDistance = parseInt(filters.endingDistance, 10);
  }


  return fetchFilters

}

export const getDriverFetchFilters = (filters) => {
  const fetchFilters = {};

  if (filters.driverCity != "all") {
    fetchFilters.cityId = +filters.driverCity;
  }

  if (filters.shiftTemplateId != "all") {

    fetchFilters.shiftTemplateId = +filters.shiftTemplateId;
  }
  if (filters.driverVehicle != "all") {
    fetchFilters.vehicleType = +filters.driverVehicle;
  }

  if (filters.driverNationality != "all") {
    fetchFilters.nationality = filters.driverNationality;
  }


  if (filters.driverVehicleModel != "all") {
    fetchFilters.vehicleModel = filters.driverVehicleModel;
  }

  if (filters.driverUniform != "all") {
    fetchFilters.dress = +filters.driverUniform;
  }

  if (filters.driverDevice != "all") {
    fetchFilters.deviceType = filters.driverDevice;
  }

  if (filters.driverPartner != "all") {
    fetchFilters.partnerId = +filters.driverPartner;
  }

  if (filters.driverLastSeen) {
    fetchFilters.lastSeen = moment().subtract(+filters.driverLastSeen, "days").format("YYYY-MM-DD")
  }

  if (filters.driverStatus != "all") {
    switch (filters?.driverStatus) {
      case "free":
        fetchFilters.isOnline = true
        fetchFilters.isBusy = false
        break
      case "busy":
        fetchFilters.isOnline = true
        fetchFilters.isBusy = true
        break
      case "offline":
        fetchFilters.isOnline = false
        break
    }

  }

  return fetchFilters

}

export const getBillingFetchFilters = (filters) => {
  const fetchFilters = {};

  if (filters.merchantName != "all") {
    fetchFilters.merchantName = filters.merchantName;
  }

  if (filters.startPeriod != "all") {
    fetchFilters.startPeriod = filters.startPeriod;
  }

  if (filters.endPeriod != "all") {
    fetchFilters.endPeriod = filters.endPeriod;
  }


  if (filters.paymentState != "all") {
    fetchFilters.paymentState = filters.paymentState;
  }

  return fetchFilters

}